import React, { useRef } from "react";
import Chart from "react-apexcharts";
import { PrimaryButton } from "../buttons/PrimaryButton";
// @ts-ignore
import { useScreenshot } from "use-react-screenshot";

interface Props {
  active: number;
  inactive: number;
  className?: string;
}

export const DroppersBreakdownChart = React.memo(
  ({ active, inactive, className }: Props) => {
    /** Refs */
    const snapshotRef = useRef(null);
    /** Hooks */
    const [, takeScreenshot] = useScreenshot();

    /** Callbacks */
    const downloadScreenshot = () => {
      takeScreenshot(snapshotRef.current).then((image: any) => {
        // Create a link to download the image
        const link = document.createElement("a");
        link.href = image;
        link.download = "droppers_breakdown.png"; // Set the default file name
        link.click(); // Programmatically click the link to trigger download
      });
    };

    const activePercentage = ((active / (active + inactive)) * 100).toFixed(0);
    const inactivePercentage = ((inactive / (active + inactive)) * 100).toFixed(
      0
    );

    const chartData = {
      type: "pie" as const,
      options: {
        chart: {
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: true,
          formatter: function (_val: any, opts: any) {
            const labels = ["Active", "Inactive"];
            const values = [active, inactive];
            const percentages = [activePercentage, inactivePercentage];
            return `${labels[opts.seriesIndex]}\n${values[opts.seriesIndex]} (${percentages[opts.seriesIndex]}%)`;
          },
          style: {
            fontSize: "14px",
            fontFamily: "Satoshi",
            fontWeight: "bold",
            colors: ["#000000"],
          },
        },
        colors: ["#7DD3C0", "#CCFBF1"], // Cyan-400 and Cyan-100 for active/inactive
        labels: ["Active", "Inactive"],
        legend: {
          show: false,
        },
        plotOptions: {
          pie: {
            startAngle: 0,
            endAngle: 360,
            expandOnClick: false,
            offsetX: 0,
            offsetY: 0,
            customScale: 1,
            dataLabels: {
              offset: -20,
              minAngleToShowLabel: 10,
            },
          },
        },
        tooltip: {
          enabled: true,
          theme: "light",
          y: {
            formatter: function (value: number) {
              return value.toLocaleString();
            },
          },
        },
      },
      series: [active, inactive],
    };

    return (
      <div className="flex flex-col w-full p-2 sm:p-7 bg-white  border-gray-border rounded-xl shadow-none">
        <div className="flex flex-col sm:flex-row w-full items-start justify-between mb-1">
          <p></p>
          <PrimaryButton
            size="sm"
            onClick={downloadScreenshot}
            label="Download image"
            className="!bg-droppie-oranje !border-droppie-oranje active:!bg-droppie-oranje-dark"
          />
        </div>
        <div
          ref={snapshotRef}
          className="flex items-center flex-col justify-center"
        >
          <p className="font-satoshi text-start w-full  font-bold text-lg sm:text-2xl text-tailgrids-black  sm:mb-0">
            Regular Droppers Breakdown
          </p>
          <Chart
            {...chartData}
            height={400}
            width={400}
            key={`${active}-${inactive}`}
          />
        </div>
      </div>
    );
  }
);
